var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurriculumPhonics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 227,
    viewBox: "0 0 233 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_197_15115)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 145,
    width: 32,
    height: 66,
    rx: 5,
    fill: "#F3F3F3",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.721 195.64C166.081 195.64 169.361 192.4 169.361 185.88V171.36C169.361 169.52 168.201 168.4 166.561 168.4C165.001 168.4 164.161 169.4 163.881 170.44H163.841C162.961 169.2 161.361 168.2 158.801 168.2C155.601 168.2 153.281 169.92 152.281 173C151.841 174.36 151.641 175.92 151.641 177.72C151.641 179.56 151.841 181.08 152.281 182.44C153.281 185.52 155.601 187.24 158.801 187.24C161.121 187.24 162.681 186.44 163.721 185.08H163.761V186.64C163.761 189.48 162.481 190.8 160.001 190.8C159.081 190.8 158.081 190.48 157.201 190C156.401 189.56 155.721 189.28 155.001 189.28C153.641 189.28 152.641 190.4 152.641 191.64C152.641 192.24 152.881 192.92 153.401 193.48C154.361 194.56 157.081 195.64 159.721 195.64ZM160.561 182.56C159.081 182.56 158.161 181.88 157.681 180.44C157.441 179.72 157.321 178.8 157.321 177.76C157.321 176.72 157.441 175.76 157.681 175.04C158.161 173.6 159.081 172.92 160.561 172.92C162.041 172.92 162.921 173.6 163.401 175.04C163.641 175.76 163.761 176.72 163.761 177.76C163.761 178.8 163.641 179.72 163.401 180.44C162.921 181.88 162.041 182.56 160.561 182.56Z",
    fill: "#DDDDDD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_197_15115)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 145,
    width: 39,
    height: 66,
    rx: 5,
    fill: "#1CB0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.508 166.68C122.268 166.68 123.668 165.28 123.668 163.52C123.668 161.76 122.268 160.36 120.508 160.36C118.748 160.36 117.348 161.76 117.348 163.52C117.348 165.28 118.748 166.68 120.508 166.68ZM120.508 188.24C122.108 188.24 123.308 187.12 123.308 185.28V171.36C123.308 169.52 122.108 168.4 120.508 168.4C118.868 168.4 117.708 169.52 117.708 171.36V185.28C117.708 187.12 118.868 188.24 120.508 188.24Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_197_15115)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 145,
    width: 40,
    height: 66,
    rx: 5,
    fill: "#DFFEC5",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3044 195.44C71.9044 195.44 73.1044 194.32 73.1044 192.48V186.36H73.1444C73.9044 187.48 75.5444 188.44 78.0644 188.44C81.2244 188.44 83.7844 186.56 84.7844 183.52C85.2644 182.08 85.4644 180.48 85.4644 178.32C85.4644 176.16 85.2644 174.56 84.7844 173.12C83.7844 170.08 81.2244 168.2 78.0644 168.2C75.5444 168.2 73.9044 169.2 73.0244 170.44H72.9844C72.7044 169.4 71.8644 168.4 70.3044 168.4C68.6644 168.4 67.5044 169.52 67.5044 171.36V192.48C67.5044 194.32 68.6644 195.44 70.3044 195.44ZM76.4244 183.72C74.9444 183.72 73.9444 182.96 73.4644 181.48C73.2244 180.76 73.1044 179.68 73.1044 178.32C73.1044 176.96 73.2244 175.88 73.4644 175.16C73.9444 173.68 74.9444 172.92 76.4244 172.92C77.9044 172.92 78.9444 173.68 79.4244 175.16C79.6644 175.88 79.7844 176.96 79.7844 178.32C79.7844 179.68 79.6644 180.76 79.4244 181.48C78.9444 182.96 77.9044 183.72 76.4244 183.72Z",
    fill: "#58CC02"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.64 22.6924H131.681C142.94 22.6924 152.067 31.8192 152.067 43.0778V71.1024C152.067 82.3609 142.94 91.4878 131.681 91.4878H101.64C90.381 91.4878 81.2542 82.3609 81.2542 71.1024V43.0778C81.2542 31.8192 90.381 22.6924 101.64 22.6924Z",
    fill: "#CE82FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.369 14.6881C105.487 15.1973 105.195 16.342 105.716 17.2448L114.021 31.6298C114.542 32.5326 115.68 32.8516 116.562 32.3424C121.325 29.5926 122.904 23.4113 120.09 18.5362C117.275 13.6611 111.132 11.9383 106.369 14.6881Z",
    fill: "#CE82FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.946 11.0977C119.205 11.0977 118.604 11.7203 118.604 12.4885V24.7277C118.604 25.4958 119.205 26.1185 119.946 26.1185C123.945 26.1185 127.188 22.756 127.188 18.6081C127.188 14.4602 123.945 11.0977 119.946 11.0977Z",
    fill: "#CE82FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.78 45.2246C130.817 45.2246 134.9 49.3077 134.9 54.3444V62.9277C134.9 67.9645 130.817 72.0475 125.78 72.0475C121.827 72.0475 118.461 69.532 117.196 66.0142C115.933 69.532 112.567 72.0475 108.614 72.0475C103.577 72.0475 99.4939 67.9645 99.4939 62.9277V54.3444C99.4939 49.3077 103.577 45.2246 108.614 45.2246C112.567 45.2246 115.933 47.7402 117.198 51.2579C118.461 47.7402 121.827 45.2246 125.78 45.2246Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.567 48.4971C127.634 48.4971 130.121 50.9836 130.121 54.051V60.1098C130.121 63.1772 127.634 65.6637 124.567 65.6637C121.5 65.6637 119.013 63.1772 119.013 60.1098V54.051C119.013 50.9836 121.5 48.4971 124.567 48.4971Z",
    fill: "#4B4B4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.555 48.4971C113.623 48.4971 116.109 50.9836 116.109 54.051V60.1098C116.109 63.1772 113.623 65.6637 110.555 65.6637C107.488 65.6637 105.001 63.1772 105.001 60.1098V54.051C105.001 50.9836 107.488 48.4971 110.555 48.4971Z",
    fill: "#4B4B4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.686 54.9351C106.76 54.9351 108.442 53.2539 108.442 51.1799C108.442 50.2815 108.126 49.4568 107.6 48.8105L105.002 51.1799L104.233 54.9351H104.686Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.478 54.2023C118.101 54.6627 118.872 54.9348 119.707 54.9348C121.781 54.9348 123.462 53.2535 123.462 51.1796C123.462 50.1717 123.065 49.2565 122.419 48.582L120.47 49.7079L117.478 54.2023Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.225 32.2521L133.589 35.029C135.306 35.4891 136.325 37.254 135.865 38.9711L135.032 42.0802C134.572 43.7973 132.807 44.8163 131.09 44.3562L120.726 41.5793C119.009 41.1192 117.99 39.3542 118.45 37.6372L119.283 34.5281C119.743 32.811 121.508 31.792 123.225 32.2521Z",
    fill: "#6F4EA1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.499 35.029L109.863 32.2521C111.58 31.792 113.345 32.811 113.805 34.5281L114.638 37.6372C115.098 39.3542 114.079 41.1192 112.362 41.5793L101.998 44.3562C100.281 44.8163 98.5162 43.7973 98.0561 42.0802L97.223 38.9711C96.7629 37.254 97.7819 35.4891 99.499 35.029Z",
    fill: "#6F4EA1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.675 28.0871L165.885 45.5543C167.267 48.175 166.263 51.4198 163.642 52.8017C162.871 53.2085 162.012 53.421 161.14 53.421H142.72C139.757 53.421 137.355 51.0192 137.355 48.0564C137.355 47.1844 137.568 46.3256 137.974 45.5543L147.184 28.0871C148.566 25.4664 151.811 24.4621 154.432 25.844C155.389 26.3485 156.171 27.1304 156.675 28.0871Z",
    fill: "#ECB2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8626 28.0871L95.0728 45.5543C96.4547 48.175 95.4504 51.4198 92.8296 52.8017C92.0583 53.2085 91.1995 53.421 90.3275 53.421H71.9071C68.9443 53.421 66.5425 51.0192 66.5425 48.0564C66.5425 47.1844 66.755 46.3256 67.1617 45.5543L76.372 28.0871C77.7539 25.4664 80.9987 24.4621 83.6194 25.844C84.5762 26.3485 85.3581 27.1304 85.8626 28.0871Z",
    fill: "#ECB2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.183 72.2311V78.6C132.183 82.7479 128.82 86.1104 124.673 86.1104H109.652C105.504 86.1104 102.141 82.7479 102.141 78.6V72.2311C102.141 68.0832 105.504 64.7207 109.652 64.7207H124.673C128.82 64.7207 132.183 68.0832 132.183 72.2311Z",
    fill: "#ECB2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.832 69.4785C113.906 69.4785 115.587 71.1598 115.587 73.2337V76.4525C115.587 78.5264 113.906 80.2077 111.832 80.2077C109.758 80.2077 108.077 78.5264 108.077 76.4525V73.2337C108.077 71.1598 109.758 69.4785 111.832 69.4785Z",
    fill: "#CE82FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.561 69.4785C124.635 69.4785 126.316 71.1598 126.316 73.2337V76.4525C126.316 78.5264 124.635 80.2077 122.561 80.2077C120.487 80.2077 118.805 78.5264 118.805 76.4525V73.2337C118.805 71.1598 120.487 69.4785 122.561 69.4785Z",
    fill: "#CE82FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 111,
    width: 199,
    height: 11,
    rx: 5.5,
    fill: "#FFC800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_197_15115",
    x: 145,
    y: 145,
    width: 32,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.952941 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_15115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_197_15115",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_197_15115",
    x: 101,
    y: 145,
    width: 39,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.564706 0 0 0 0 0.815686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_15115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_197_15115",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_197_15115",
    x: 56,
    y: 145,
    width: 40,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.996078 0 0 0 0 0.772549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_15115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_197_15115",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurriculumPhonics);
export default __webpack_public_path__ + "static/media/curriculum-phonics.2f21e783114aa87205e6f83a9affe3d4.svg";
export { ForwardRef as ReactComponent };